import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import { ADMIN_PREFIX } from '../config';
import {
  IServiceFeeModelResItem,
  ICreateServiceFeeModel,
} from '../../model/api-modules/price-calculator';

// 获取计费模型列表
export const getAdminServiceFeeList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service-fee/model`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<{ list: IServiceFeeModelResItem[] }>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      return false;
    }
  });
// 创建计费模型
export const createAdminServiceFee = (body: ICreateServiceFeeModel) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service-fee/model`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'code');
      return res;
    } catch (error: any) {
      return error?.apiError;
    }
  });
// 更新计费模型
export const updateAdminServiceFee = (
  id: number,
  body: ICreateServiceFeeModel
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service-fee/model/${id}`;
      const response = await api.commonRequest('PUT', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'code');
      return res;
    } catch (error: any) {
      return error?.apiError;
    }
  });
// 删除计费模型
export const deleteAdminServiceFee = (id: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service-fee/model/${id}`;
      const response = await api.commonRequest('DELETE', url);
      const res = await parsedResponse<IAPIresponse>(response, 'code');
      return res;
    } catch (error: any) {
      return error?.apiError;
    }
  });
